import React, { useState } from 'react';
import { Steps } from 'antd';
import {
  ShopOutlined,
  FileTextOutlined,
  CreditCardOutlined,
} from '@ant-design/icons';
import BusinessDetailsStep from './BusinessDetailsStep';
import AgreementStep from './AgreementStep';
import PaymentStep from './PaymentStep';
import './AgreementsPage.css';

const steps = [
  { number: 1, title: 'Business Details' },
  { number: 2, title: 'Review Agreement' },
  { number: 3, title: 'Payment Details' },
];

const AgreementsPage = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [agreementApproved, setAgreementApproved] = useState(false);
  const [otp, setOtp] = useState('');
  const [otpVerified, setOtpVerified] = useState(false);
  const [otpError, setOtpError] = useState('');
  const [form, setForm] = useState({
    businessName: 'Store 1688',
    legalBusinessName: 'K & L Solutions',
    ownerName: 'Po Zhang',
    title: 'Owner',
    email: 'infostore1688@gmail.com',
    phone: '+1 832868598',
    businessAddress: '14905 Southwest Fwy STE222',
    city: 'Sugar Land',
    state: 'TX',
    zipCode: '77478',
    agreementConfirmed: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === 'agreementConfirmed' && !checked) {
      setAgreementApproved(false);
    }

    setForm((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const verifyOtp = () => {
    if (otp === '357281') {
      setOtpVerified(true);
      setOtpError('');
    } else {
      setOtpError('Invalid OTP. Please try again.');
    }
  };

  const validateBusinessDetails = () => {
    return (
      form.businessName.trim() &&
      form.legalBusinessName.trim() &&
      form.ownerName.trim() &&
      form.title.trim() &&
      form.email.trim() &&
      form.phone.trim() &&
      form.businessAddress.trim() &&
      form.city.trim() &&
      form.state.trim() &&
      form.zipCode.trim()
    );
  };

  const handleNext = () => {
    if (currentStep === 1 && !validateBusinessDetails()) {
      alert('Please complete all required business details before continuing.');
      return;
    }

    if (currentStep === 2 && !agreementApproved) {
      alert('Please click Confirm Agreement before continuing to Payment.');
      return;
    }

    setCurrentStep((prev) => Math.min(prev + 1, steps.length));
  };

  const handleBack = () => {
    setCurrentStep((prev) => Math.max(prev - 1, 1));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    console.log('Agreement onboarding data:', form);

    // Later: call backend API here
    // POST /agreements/onboarding
    // Then redirect customer to Stripe Checkout or Stripe payment setup page

    alert('Business details and agreement confirmation submitted. Continue to payment setup.');
  };

  const renderCurrentStep = () => {
    if (currentStep === 1) {
      return <BusinessDetailsStep form={form} handleChange={handleChange} />;
    }

    if (currentStep === 2) {
      return (
        <AgreementStep
          form={form}
          handleChange={handleChange}
          onAgreementConfirmed={() => {
            setAgreementApproved(true);
            setCurrentStep(3);
          }}
        />
      );
    }

    return <PaymentStep />;
  };

  const stepItems = [
    {
      title: 'Business Details',
      description: 'Business Information',
      icon: <ShopOutlined />,
      status: currentStep > 1 ? 'finish' : 'process',
    },
    {
      title: 'Agreement',
      description: agreementApproved ? 'Confirmed' : 'Review & Sign',
      icon: <FileTextOutlined />,
      status: agreementApproved ? 'finish' : currentStep === 2 ? 'process' : 'wait',
    },
    {
      title: 'Payment',
      description: 'Setup Billing',
      icon: <CreditCardOutlined />,
      status: currentStep === 3 ? 'process' : 'wait',
    },
  ];

  if (!otpVerified) {
    return (
      <div className="agreements-page">
        <div className="agreements-card" style={{ maxWidth: '500px', margin: '80px auto' }}>
          <h1>TrackBiz Customer Onboarding</h1>

          <h2>OTP Verification</h2>
          <p>Please enter the OTP provided by Club Sports Solutions to continue.</p>

          <input
            type="text"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            placeholder="Enter OTP"
            style={{ width: '100%', padding: '12px', marginBottom: '12px' }}
          />

          {otpError && (
            <div style={{ color: 'red', marginBottom: '12px' }}>
              {otpError}
            </div>
          )}

          <button type="button" onClick={verifyOtp}>
            Verify OTP
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="agreements-page">
      <div className="agreements-card">
        <h1>TrackBiz Customer Onboarding</h1>

        <div className="agreements-steps-container">
          <Steps
            current={currentStep - 1}
            items={stepItems}
            size="small"
            responsive
          />
        </div>

        <form onSubmit={handleSubmit}>
          {renderCurrentStep()}

          <div className="agreements-actions">
            {currentStep > 1 && (
              <button type="button" className="secondary-button" onClick={handleBack}>
                Back
              </button>
            )}

            {currentStep < steps.length ? (
              <button
                type="button"
                onClick={handleNext}
                disabled={currentStep === 2 && !agreementApproved}
              >
                Continue
              </button>
            ) : (
              <button type="submit">Continue to Payment</button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default AgreementsPage;